import React from 'react';
import { IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import './customDateRange.scss';

const CustomDay = (props) => {
  const {
    filled,
    outlined,
    highlighted,
    disabled,
    startOfRange,
    endOfRange,
    onClick,
    onHover,
    value,
  } = props;

  return (
    <div
      className={`day-button-container ${
        startOfRange ? 'left-border-radius' : ''
      } ${endOfRange ? 'right-border-radius' : ''} ${
        !disabled && highlighted ? 'highlighted' : ''
      }`}
    >
      <IconButton
        className={`day-button ${!disabled && outlined ? 'outlined' : ''} ${
          !disabled && filled ? 'filled' : ''
        }`}
        disabled={disabled}
        onClick={onClick}
        onMouseOver={onHover}
      >
        <Typography
          variant="body2"
          className={`${!disabled && filled ? 'filled-text' : 'default-text'}`}
        >
          {!disabled && value}
        </Typography>
      </IconButton>
    </div>
  );
};

CustomDay.propTypes = {
  filled: PropTypes.bool,
  outlined: PropTypes.bool,
  highlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  startOfRange: PropTypes.bool,
  endOfRange: PropTypes.bool,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomDay;
